import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { HttpService } from '../../services/http.service';

@Component({
  selector: 'app-icono-persona',
  templateUrl: './icono-persona.component.html',
  styleUrls: ['./icono-persona.component.css']
})
export class IconoPersonaComponent implements OnChanges, OnDestroy {
  @Input() keyImg: string;
  @Input() alt: string = '';

  imgUrl: string;
  private sub: Subscription;

  constructor(private dataService: HttpService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.keyImg) {
      this.cargarImagen();
    }
  }

  ngOnDestroy(): void {
    this.limpiar();
  }

  private cargarImagen() {
    this.limpiar();
    if (!this.keyImg) {
      console.warn('[img] la persona no trae keyImg');
      return;
    }
    // Si ya viene el enlace completo se usa directo
    if (/^https?:\/\//i.test(this.keyImg)) {
      console.log('[img] url directa', this.keyImg);
      this.imgUrl = this.keyImg;
      return;
    }
    console.log('[img] solicitando imagen', this.keyImg);
    this.sub = this.dataService.getImagen(this.keyImg).subscribe((url:any) => {
      console.log(url,11)
      this.imgUrl = url.data[0].table0[0].url;
      console.log(this.imgUrl);
    }, error => console.warn('[img] error al obtener la imagen', error));
  }

  // Si la URL firmada expira o no carga, se vuelve al icono por defecto
  // onError() {
  //   console.warn('[img] no se pudo cargar la imagen', this.imgUrl);
  //   this.imgUrl = null;
  // }

  private limpiar() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    this.imgUrl = null;
  }

}
